import Vue from "vue"
import * as VueMoment from "vue-moment"
import Moment from 'moment';
import 'moment/locale/fr';


Moment.locale('fr');
Vue.use(VueMoment, {moment : Moment});
